import { defineStore } from 'pinia';
import LandingPageApiService from '@/services/api/LandingPageApiService';

const HTTP_NOT_FOUND = 404;

// La promesa se comparte entre el guard del router y PaginasLanding para hacer una sola petición
let homepagePromise = null;

export const usePaginaStore = defineStore('paginaStore', {
  state: () => ({
    pagina: null,
  }),
  actions: {
    /**
     * Homepage dinámica publicada de la agencia, o null si no tiene (el back responde 404).
     * Cualquier otro error se propaga y no se cachea, para poder reintentar.
     */
    fetchHomepage() {
      if (!homepagePromise) {
        homepagePromise = LandingPageApiService.getHomepage().catch(error => {
          if (error?.response?.status === HTTP_NOT_FOUND) {
            return null;
          }
          homepagePromise = null;
          throw error;
        });
      }
      return homepagePromise;
    },
  },
});
